import saveSurveyData from "@app/controllers/bare_forms/form_functions/saveSurveyData";
import getEulogy from "@app/controllers/bare_forms/form_functions/getEulogy";
import evaluateDefaultExpressions from "@app/controllers/bare_forms/form_functions/evaluateDefaultExpressions";

export default async (survey, config) => {
  // Evaluate all defaultValueExpression fields before saving
  evaluateDefaultExpressions(survey);

  saveSurveyData(survey, true, false, config.urls.response).then(() => {
    if (window.location.href.includes("preconsultation_form")) {
      window.location.reload();
    } else if (!isDealStage(config.defaultResponse)) {
      redirectTo(survey, "form/success");
    }
  });

  if (config.urls.complete && document.querySelector(".eulogies")) {
    getEulogy(config.urls.checkSubmitted, config.urls.complete);
  }
};

function isDealStage(defaultResponse) {
  if (defaultResponse !== undefined && defaultResponse !== null) {
    return defaultResponse["dashboard_stage"] === "deal";
  } else {
    return false;
  }
}

async function redirectTo(survey, page) {
  try {
    window.location.href = window.location.href.replace("form", page);
  } catch {
    console.error("Failed to save survey data before redirecting.");
  }
}
